module.exports = "li{\n  padding: 5px 0px;\n}\nli:hover{\n color:#fb625c;\n}\n.li-item-active{\n  color:#fb625c!important;\n}\n.popover-style{\n  border: #dee2e6 1px solid;\n  z-index: 20;\n  position: absolute;\n  right: 2em;\n  top: 2em;\n  background: #f9f9f9;\n  padding: 4px 15px 9px 16px;\n  font-size: 14px;\n  text-align: left;\n  opacity: 1;\n  color: #fb625c;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/feature/main/roles-shared/components/benchmark-popover/benchmark-popover.component.css
// module id = ./src/app/feature/main/roles-shared/components/benchmark-popover/benchmark-popover.component.css
// module chunks = main